import api from './Api';

export interface PasswordResetRequest {
  currentPassword: string;
  newPassword: string;
}

export interface EmailUpdateRequest {
  newEmail: string;
}

export interface User {
  id: number;
  username: string;
  email?: string;
  role: string;
}

export const UserApi = {
  // Reset password for current user or specific user (if admin)
  resetPassword: async (userId: number, request: PasswordResetRequest): Promise<string> => {
    const response = await api.post(`/users/${userId}/reset-password`, request);
    return response.data;
  },

  // Update email for current user or specific user (if admin)
  updateEmail: async (userId: number, request: EmailUpdateRequest): Promise<string> => {
    const response = await api.post(`/users/${userId}/update-email`, request);
    return response.data;
  },

  // Admin-only: Reset password without current password. Optionally pass a custom password; omit to auto-generate.
  adminResetPassword: async (userId: number, customPassword?: string): Promise<{ generatedPassword: string; message: string }> => {
    const body = customPassword ? { customPassword } : undefined;
    const response = await api.post(`/users/${userId}/admin-reset-password`, body);
    return response.data;
  },

  // Get user profile
  getUserProfile: async (userId: number): Promise<User> => {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  }
};

export default UserApi;
